var Truncator = /** @class */ (function () {
    function Truncator() {
    }
    /**
     * Truncate a string removing markup and whitespace
     *
     * @static
     * @param {string} markup - An html string
     * @param {number} [length] - The length of the final string including delimiter
     * @param {string} [delimiter] - The delimiter to denote truncation at the end of the truncated string
     * @returns
     *
     * @memberOf Truncator
     */
    Truncator.stripMarkupAndTruncate = function (markup, length, delimiter) {
        if (length === void 0) { length = Truncator.truncateLength; }
        if (delimiter === void 0) { delimiter = Truncator.delimiter; }
        // Add the the markup to an HTMLElement and remove its text content to remove html
        var tempElement = document.createElement('div');
        tempElement.innerHTML = markup;
        // Remove style element often found in document head
        var style = tempElement.getElementsByTagName('style')[0];
        if (style) {
            style.parentElement.removeChild(style);
        }
        var t = (tempElement.innerText || tempElement.textContent).trim()
            .replace('&nbsp;', '')
            .replace(/[\s\s]+/g, ' ')
            .replace(/[\r\n]+/g, ' ');
        return (t.length > length)
            ? t.substring(0, length - delimiter.length) + delimiter
            : t;
    };
    Truncator.truncateLength = 60;
    Truncator.delimiter = '…';
    return Truncator;
}());
export { Truncator };
